module.exports = __webpack_public_path__ + "img/31_10.89cff1bc.png";